export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_07.3b359d42.jpg";